import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = { class: "col-span-12" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_9 = {
  key: 0,
  class: "grid grid-cols-4 gap-6 pt-6 mb-6 border-t mx-7"
}
const _hoisted_10 = {
  key: 1,
  class: "mb-6 text-right px-7"
}
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_18 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_21 = {
  key: 2,
  class: "text-right p-7"
}
const _hoisted_22 = ["innerHTML"]

import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

import { ref, watch, computed, onMounted } from 'vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import BookingService from '@/classes/BookingService';
import { format } from 'date-fns';
import { useRouter, useRoute } from 'vue-router';
import { 
    Employee,
    updateCorporatePatientListPayload
} from '@/interfaces/CorporateBookingInterface';
import { useNetworkStore } from '@/store/network';
import { onIonViewWillEnter } from '@ionic/vue';
import { formateTimeSlot } from "@/helpers/TimeFormatter"


export default /*@__PURE__*/_defineComponent({
  __name: 'CorporateEditFormSection',
  emits: ["fetched-item"],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const route = useRoute();

// defineProps({
//     isNetworkAvailable: {
//         type: Boolean,
//         default: true,
//     },
// });
const noAction = ref(true)
const loader = ref(false)
const showError = ref(false)
const errorMsg = ref()
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)
const csvFile = ref();
const cancelBooking = ref(false)

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const headers: { text: string }[] = [
    { text: 'First Name' },
    { text: 'Middle Name' },
    { text: 'Last Name' },
    { text: 'Suffix' },
    { text: 'Email' },
    { text: 'Gender' },
    { text: 'Birthday' },
    // { text: 'Resend Email' },
    { text: '' },
    { text: '' },
];

const sexes = [
    { id: '1', label: 'Male', value: 'Male' },
    { id: '2', label: 'Female', value: 'Female' },
    // { id: '3', label: 'Prefer not to Say', value: 'Prefer not to Say' },
];

const patientDefaultValues = {
    cellphone_number : "TBA",
    telephone_number : "TBA",
    civil_status     : "TBA",
    nationality      : "TBA",
    religion         : "TBA",
    job_title        : "TBA",
    birthplace       : "TBA",
    building_number  : "TBA",
    street           : "TBA",
    barangay         : "TBA",
    city             : "TBA",
    province         : "TBA",
    region           : "TBA",
    zip_code         : "TBA",
    philhealth_number: "000000000"
};

const bookingId  = ref(Number(route.params.bookingId)) as unknown as number;
const employeeCount = ref(0);
const unformattedBookingDate = ref(null);
const corporateBooking = ref({});
const timeSlot = ref<string>('');
const successMsg = ref()
const patient_type = ref(route.query.patient_type);

const packageName = computed(() => {
    return corporateBooking.value.package_name;
});

const employee = ref<Employee>({
    suffix : null,
    first_name : null,
    middle_name : null,
    last_name : null,
    email_address : null,
    sex : null,
    birthdate : null,
})

const payload = ref<updateCorporatePatientListPayload>({
    corporate_booking_id: bookingId,
    patients: [],
});

const emit = __emit

const isEmailValid = (email: string) => {
    const reg = /[^\s@]+@[^\s@]+\.[^\s@]+/;

    if(email) {
        return reg.test(email) ? true : false;
    }
    
    return false;
}

const validateEmployee = () => {
    if(
        employee.value.first_name == null ||
        employee.value.last_name == null ||
        employee.value.email_address == null ||
        employee.value.sex == null ||
        employee.value.birthdate == null
    ) {
        showError.value = true;
        errorMsg.value = "Please fill up all the patient fields.";
    } else if(!isEmailValid(employee.value.email_address)) {
        showError.value = true;
        errorMsg.value = "Please input a valid email address";
    } else {
        addEmployee();
    }
}

const addEmployee = () => {
    const birthdate = new Date(employee.value.birthdate).toISOString().split('T')[0];

    const patientDetails = {
        suffix : employee.value.suffix, 
        first_name : employee.value.first_name,
        middle_name : employee.value.middle_name,
        last_name : employee.value.last_name,
        email_address : employee.value.email_address,
        sex : employee.value.sex,
        birthdate : birthdate, 
    };

    payload.value.patients.push(Object.assign(patientDetails, patientDefaultValues));

    employeeCount.value++;
    
    resetEmployeeFields();
}

const removeEmployee = (index: number) => {
    payload.value.patients.splice(index, 1);
    employeeCount.value--;
};

const resetEmployeeFields = () => {
    const keys = Object.keys(employee.value);
    keys.forEach(key => employee.value[key] = null);
}

const redirectToBookingIndex = () => {
    showSuccess.value = false;
    router.push(`/branches/${route.params.branchId}/bookings`);
}

const patientExists = (email_address: string) => {
    return payload.value.patients.some(patient => patient.email_address == email_address)
}

const pushPatientList = () => {
    if(corporateBooking.value.employee_list && corporateBooking.value.employee_list.length > 0) {
        const activeBookings = corporateBooking.value.employee_list
                                .filter(booking => booking.status == 'Booked' || booking.status == 'Done')
                                .sort((a, b) => b.booking_id - a.booking_id);
                            
        activeBookings.forEach(booking => {
            const employee_birthdate = new Date(booking.patient.birthdate).toISOString().split('T')[0]
    
            if(!patientExists(booking.patient.email_address)) {
                const patientDetails = {
                    suffix : booking.patient.suffix, 
                    first_name : booking.patient.first_name,
                    middle_name : booking.patient.middle_name,
                    last_name : booking.patient.last_name,
                    email_address : booking.patient.email_address,
                    sex : booking.patient.sex,
                    birthdate : employee_birthdate,
                    status : booking.status,
                    booking_id: booking.booking_id,
                };

                payload.value.patients.push(Object.assign(patientDetails, patientDefaultValues));
                employeeCount.value++;
            }
        });
    }
}

const buildCancelPayload = () => {
    if(patient_type.value == 'Individual' || patient_type.value == 'Dependent') {
        return {
            booking_email: employee.value.email_address,
        };
    } else if (patient_type.value == 'Corporate'){
        return {
            // corporate_booking_email: employee.value.email_address,
            booking_id: specificBookingId.value,
            remarks: "Booking cancellation no show remarks",
            updated_by: "Admin"
        };
    }

    return {};
}

const specificBookingId = ref(null)
const cancelSpecific = (bookingId: any) => {
    cancelBooking.value = true;
    specificBookingId.value = bookingId;
}

const submitCancelSpecific = () => {
    loader.value = true;

    BookingService.submitCancelSpecific(patient_type.value, buildCancelPayload())
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                cancelBooking.value = false;
                successMsg.value    = "Appointment has been successfully marked as cancelled";
                showSuccess.value   = true;
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value  = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

/**
 * Return the formatted time picker formatted values.
 *
 * @param  string[] time
 * @return object
 */
const timePickerFormat = (time: string[]) => {
    return {
        hours  : time[0],
        minutes: time[1],
        seconds: '00'
    };
}

/**
 * Get the formatted time string array.
 *
 * @param  string|null time
 * @return string[]
 */
const getFormattedTime = (time: string|null) => {
    if(time) {
        const timeSplit  = new Date(corporateBooking.value.booking_time_start).toISOString().split('T')[1];
        const timeStringArray = timeSplit.split(":")

        return timePickerFormat(timeStringArray)
    }

    return null;
}

const fetchCorporateBooking = () => {
    loader.value = true;

    BookingService.fetchCorporateBooking(route.params.bookingId)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                corporateBooking.value = result.data.response.response;

                timeSlot.value = formateTimeSlot(corporateBooking.value.booking_time_start, corporateBooking.value.booking_time_end)
                unformattedBookingDate.value = new Date(corporateBooking.value.booking_date).toISOString().split('T')[0]
            
                corporateBooking.value.booking_time_start = getFormattedTime(corporateBooking.value.booking_time_start);

                emit("fetched-item", corporateBooking.value);
                pushPatientList()
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const updateCorporatePatients = () => {
    loader.value = true;

    BookingService.updateCorporatePatientsList(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.response.result_status == 200 && result.data.response.message == 'Success') {
                showSuccess.value = true;
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value = "Something went wrong. Please try again later";
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const isDateValid = (dateString: string) => {
    const timestamp = Date.parse(dateString);
    if (isNaN(timestamp)) {
        return false;
    } else {
        return true;
    }
}

const pushEmployeesFromCsv = () => {
    if(csvFile.value) {
        // FileReader Object
        const reader = new FileReader();
        // Read file as string 
        reader.readAsText(csvFile.value);

        // Load event
        reader.onload = function(event) {

            // Read file data
            const csvdata = event.target.result;

            // Split by line break to gets rows Array
            const rowData = csvdata.split('\n');

            let invalidPatientCount = 0;

            // Loop on the row Array (change row=0 if you also want to read 1st row)
            for (let row = 1; row < rowData.length; row++) {

                // Split by comma (,) to get column Array
                const rowColData = rowData[row].split(',');

                if(isDateValid(rowColData[6])) {
                    employeeCount.value++;

                    const patientDetails = {
                        first_name : rowColData[0],
                        middle_name : rowColData[1],
                        last_name : rowColData[2],
                        suffix : rowColData[3], 
                        email_address : rowColData[4],
                        sex : rowColData[5],
                        birthdate : rowColData[6],
                    };

                    payload.value.patients.push(Object.assign(patientDetails, patientDefaultValues));
                } else {
                    invalidPatientCount++;
                }
            }

            if(invalidPatientCount > 0) {
                showError.value = true;
                errorMsg.value = `${invalidPatientCount} row/s were not uploaded due to incorrect birth date values`;
            }
        };
    }
}

const resendEmail = (employee) => {
    loader.value = true;

    const payload = {
        employee : employee,
        corporate_name : corporateBooking.value.corporate_name
    }

    BookingService.resendEmail(payload)
        .then(() => {
            loader.value = false;
            showSuccess.value = true;
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

watch(
    () => csvFile.value,
    () => {
        pushEmployeesFromCsv()
    },
    { immediate: true }
);


onMounted(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        fetchCorporateBooking();
    }, 1000);
})

onIonViewWillEnter(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        fetchCorporateBooking();
    }, 1000);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FormSection, null, {
      title: _withCtx(() => [...(_cache[20] || (_cache[20] = [
        _createTextVNode(" Booking Information ", -1)
      ]))]),
      description: _withCtx(() => [...(_cache[21] || (_cache[21] = [
        _createTextVNode(" Relevant data and other details ", -1)
      ]))]),
      form: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextInput, {
            "model-value": packageName.value,
            id: "packageName",
            name: "packageName",
            label: "Package",
            placeholder: "Package",
            disabled: ""
          }, null, 8, ["model-value"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm text-gray-900" }, "Riders", -1)),
          (corporateBooking.value.other_charges_details && corporateBooking.value.other_charges_details.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corporateBooking.value.other_charges_details, (rider, index) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    key: index,
                    class: "pl-5 text-sm list-disc"
                  }, [
                    _createElementVNode("li", null, _toDisplayString(rider.item_name ?? 'TBD'), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[22] || (_cache[22] = [
                _createElementVNode("p", null, "N/A", -1)
              ]))]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (unformattedBookingDate.value)
            ? (_openBlock(), _createBlock(DatePicker, {
                key: 0,
                modelValue: unformattedBookingDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((unformattedBookingDate).value = $event)),
                id: "unformattedBookingDate",
                name: "unformattedBookingDate",
                label: "Booking Date",
                placeholder: "MM/DD/YYYY",
                disabled: ""
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (unformattedBookingDate.value)
            ? (_openBlock(), _createBlock(TextInput, {
                key: 0,
                disabled: "",
                label: "Time Slot",
                placeholder: "Time Slot",
                id: "time_slot",
                name: "time_slot",
                modelValue: timeSlot.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((timeSlot).value = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            modelValue: employeeCount.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((employeeCount).value = $event)),
            id: "employeeCount",
            name: "employeeCount",
            label: "Number of Employees",
            placeholder: "Number of Employees",
            disabled: ""
          }, null, 8, ["modelValue"])
        ]),
        (isNetworkAvailable.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(DropzoneInput, {
                file: csvFile.value,
                "onUpdate:file": _cache[3] || (_cache[3] = ($event: any) => ((csvFile).value = $event)),
                label: "Participating Corporate Employees",
                description: "CSV, EXCEL file",
                accept: ".csv"
              }, null, 8, ["file"]),
              _cache[24] || (_cache[24] = _createElementVNode("a", {
                href: "/assets/files/shinagawa-patients.csv",
                download: "",
                class: "inline-block mt-3 text-blue-500"
              }, " Download Corporate Patient List Manifest ", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isNetworkAvailable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              modelValue: employee.value.first_name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((employee.value.first_name) = $event)),
              id: "first_name",
              name: "first_name",
              label: "First Name",
              placeholder: "First Name"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              modelValue: employee.value.middle_name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((employee.value.middle_name) = $event)),
              id: "middle_name",
              name: "middle_name",
              label: "Middle Name",
              placeholder: "Middle Name"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              modelValue: employee.value.last_name,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((employee.value.last_name) = $event)),
              id: "last_name",
              name: "last_name",
              label: "Last Name",
              placeholder: "Last Name"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              modelValue: employee.value.suffix,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((employee.value.suffix) = $event)),
              id: "suffix",
              name: "suffix",
              label: "Suffix",
              placeholder: "Suffix"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(TextInput, {
              modelValue: employee.value.email_address,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((employee.value.email_address) = $event)),
              id: "email_address",
              name: "email_address",
              label: "Email",
              placeholder: "Email"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(MultiselectInput, {
              modelValue: employee.value.sex,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((employee.value.sex) = $event)),
              id: "sex",
              name: "sex",
              label: "Sex",
              placeholder: "Sex",
              options: sexes
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(DatePicker, {
              modelValue: employee.value.birthdate,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((employee.value.birthdate) = $event)),
              id: "birthdate",
              name: "birthdate",
              label: "Birthday",
              placeholder: "MM/DD/YYYY"
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (isNetworkAvailable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(ButtonComponent, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (validateEmployee()))
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode(" Add Employee ", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(DataTable, {
        headers: headers,
        "no-action": noAction.value,
        count: employeeCount.value
      }, {
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payload.value.patients, (employee, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_12, _toDisplayString(employee.first_name), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(employee.middle_name), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(employee.last_name), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(employee.suffix), 1),
              _createElementVNode("td", _hoisted_16, [
                _createVNode(TextInput, {
                  modelValue: payload.value.patients[index].email_address,
                  "onUpdate:modelValue": ($event: any) => ((payload.value.patients[index].email_address) = $event),
                  id: "patient_email_address",
                  name: "patient_email_address",
                  placeholder: "Email",
                  disabled: !isNetworkAvailable.value || employee.status != 'Booked'
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]),
              _createElementVNode("td", _hoisted_17, _toDisplayString(employee.sex), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(format)(new Date(employee.birthdate), 'LLL dd, yyyy')), 1),
              (isNetworkAvailable.value && employee.status == 'Booked')
                ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                    _createVNode(ActionButton, {
                      onClick: ($event: any) => (removeEmployee(index)),
                      "close-btn": ""
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_20, [
                (employee.status != 'Done')
                  ? (_openBlock(), _createBlock(ButtonComponent, {
                      key: 0,
                      disabled: loader.value,
                      color: "bg-red-600 border-red-600",
                      onClick: ($event: any) => (cancelSpecific(employee.booking_id))
                    }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode(" Cancel ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["no-action", "count"])
    ]),
    (isNetworkAvailable.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_ctx.$hasPermission('update-participating-employees') || _ctx.$hasPermission('update-corporate-booking-information'))
            ? (_openBlock(), _createBlock(ButtonComponent, {
                key: 0,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (showConfirmation.value = true))
              }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode(" Submit ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (loader.value)
      ? (_openBlock(), _createBlock(PageLoader, { key: 3 }))
      : _createCommentVNode("", true),
    _createVNode(ErrorModal, {
      width: "w-[548px]",
      title: "Error",
      "action-text": "Close",
      "cancel-text": "Go back",
      show: showError.value,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (showError.value = false)),
      onConfirm: _cache[14] || (_cache[14] = ($event: any) => (showError.value = false)),
      errors: errors.value
    }, {
      content: _withCtx(() => [
        _createElementVNode("p", { innerHTML: errorMsg.value }, null, 8, _hoisted_22)
      ]),
      _: 1
    }, 8, ["show", "errors"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onCancel: _cache[15] || (_cache[15] = ($event: any) => (showSuccess.value = false)),
      onConfirm: _cache[16] || (_cache[16] = ($event: any) => (redirectToBookingIndex())),
      "action-text": "Confirm",
      title: "Corporate Patient List Updated!",
      content: "Corporate patient list has been updated"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: showConfirmation.value,
      onCancel: _cache[17] || (_cache[17] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[18] || (_cache[18] = ($event: any) => {showConfirmation.value = false; updateCorporatePatients() }),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Update Corporate Patient List?",
      content: "Are you sure you wish to update the patient list for this corporate booking?"
    }, null, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      show: cancelBooking.value,
      onCancel: _cache[19] || (_cache[19] = ($event: any) => (cancelBooking.value = false)),
      onConfirm: submitCancelSpecific,
      "cancel-text": "Cancel",
      "action-text": "Submit",
      title: "Cancel Booking?",
      content: "Are you sure you wish cancel this booking?"
    }, null, 8, ["show"])
  ]))
}
}

})